import { render, staticRenderFns } from "./BilformanCalcResultCardText.vue?vue&type=template&id=767fdb16&scoped=true"
import script from "./BilformanCalcResultCardText.vue?vue&type=script&lang=js"
export * from "./BilformanCalcResultCardText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "767fdb16",
  null
  
)

export default component.exports